/*
 * @Author: shannyHuang
 * @Date: 2022-08-29 11:48:56
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-29 15:42:15
 * @FilePath: /wemeet-web-activity/src/model/follow.ts
 */
import { get, post } from 'src/lib/http';
import { HttpPrefix } from 'src/lib/wemeet-http-moudle';

interface Response<T> {
  code: number;
  msg: string;
  err_detail: string;
  data: {
    is_have_more: number;
    total: number;
    page: number;
    hosts: T;
  };
}

export interface Follow {
  avatar: string;
  name: string;
  act_num: number;
  fans_num: number;
  host_id: string;
  is_in_meeting: number;
}

export const getMyFollows = (page: number, pageSize = 15) => {
  const path = '/v2/activities/user/get-host-list';
  return get<Response<Follow[]>>(
    // HttpPrefix.YAPI_API,
    HttpPrefix.WEMEET_TAPI,
    path,
    { page, page_size: pageSize },
  ).then((res) => {
    if (res.code !== 0) return Promise.reject(res.msg || res.err_detail);
    return res.data;
  });
};

export const subscribe = (id: string | number, subscribe: boolean, source = 4) => {
  const path = `/v2/activities/user/${subscribe ? '' : 'un'}subscribe`;
  return post<Response<any>>(HttpPrefix.WEMEET_TAPI, path, { host_id: id, source });
};
